export default "__VITE_ASSET__fQEe4QxD__"